{
  "header": {
    "nameShowStaticText": false,
    "nameVariable": {
      "id": "f37e1001-3cf6-4dfe-8823-2e6e87dec33c",
      "modelUri": "http://opcfoundation.org/UA/Machinery/",
      "nodeId": "ns=1;i=6033",
      "displayName": "ProductInstanceUri",
      "variablePath": "Identification.ProductInstanceUri",
      "dataType": "String",
      "valueRank": -1,
      "modellingRule": "Mandatory",
      "hasProperties": false
    },
    "modelShowStaticText": false,
    "modelVariable": {
      "id": "f37e1001-3cf6-4dfe-8823-2e6e87dec33c",
      "modelUri": "http://opcfoundation.org/UA/Machinery/",
      "nodeId": "ns=1;i=6008",
      "displayName": "Model",
      "variablePath": "Identification.Model",
      "dataType": "LocalizedText",
      "valueRank": -1,
      "modellingRule": "Optional",
      "hasProperties": false
    }
  },
  "imagesConfig": {
    "imageDefaults": {
      "[\\s\\S]*": "machine.jpg"
    }
  },
  "sections": [
    {
      "isPlaceholder": false,
      "title": "Machine Vision System Information",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Manufacturer",
              "showAsLink": false,
              "valueVariable": {
                "id": "28b20786-a9a9-4339-922b-38073581f0f1",
                "modelUri": "http://opcfoundation.org/UA/MachineVision/AMCM/",
                "nodeId": "ns=1;i=6034",
                "displayName": "Manufacturer",
                "variablePath": "Identification.Manufacturer",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Manufacturer Uri",
              "showAsLink": false,
              "valueVariable": {
                "id": "8c6dc13e-2119-4b70-af6c-2e97d7796014",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6007",
                "displayName": "ManufacturerUri",
                "variablePath": "Identification.ManufacturerUri",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Serial Number",
              "showAsLink": false,
              "valueVariable": {
                "id": "e1d55b9f-bd64-471f-ad07-2de5135c090b",
                "modelUri": "http://opcfoundation.org/UA/MachineVision/AMCM/",
                "nodeId": "ns=1;i=6035",
                "displayName": "SerialNumber",
                "variablePath": "Identification.SerialNumber",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Initial Operation Date",
              "showAsLink": false,
              "valueVariable": {
                "id": "0d6541b9-84e0-48a1-9e27-5093ccf87ed7",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6006",
                "displayName": "InitialOperationDate",
                "variablePath": "Identification.InitialOperationDate",
                "dataType": "DateTime",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Product Code",
              "showAsLink": false,
              "valueVariable": {
                "id": "9421c0bb-3ed6-4306-9609-a00fb62f7a0e",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6009",
                "displayName": "ProductCode",
                "variablePath": "Identification.ProductCode",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Location",
              "showAsLink": false,
              "valueVariable": {
                "id": "383ceed5-5f94-4bd8-8be6-9dac4b31c695",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6029",
                "displayName": "Location",
                "variablePath": "Identification.Location",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            }
          ],
          "title": "Identification"
        },
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Firmware Information",
              "showAsLink": false,
              "valueVariable": {
                "id": "59b8fa69-95db-4705-9397-462cb90e3bff",
                "modelUri": "http://opcfoundation.org/UA/MachineVision/AMCM/",
                "nodeId": "ns=1;i=6225",
                "displayName": "FirmwareInfo",
                "variablePath": "MaintenanceInfo.FirmwareInfo",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Hours in Operation",
              "showAsLink": false,
              "valueVariable": {
                "id": "49378bcd-b293-4737-9ed8-456860975a8a",
                "modelUri": "http://opcfoundation.org/UA/MachineVision/AMCM/",
                "nodeId": "ns=1;i=6004",
                "displayName": "HoursInOperation",
                "variablePath": "MaintenanceInfo.HoursInOperation",
                "dataType": "UInt64",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false,
                "hasUnit": false,
                "hasRange": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Last Calibration",
              "showAsLink": false,
              "valueVariable": {
                "id": "b7314ee5-0fce-4e8f-b79b-a113d77eabc1",
                "modelUri": "http://opcfoundation.org/UA/MachineVision/AMCM/",
                "nodeId": "ns=1;i=6006",
                "displayName": "LastCalibration",
                "variablePath": "MaintenanceInfo.LastCalibration",
                "dataType": "UtcTime",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Next Service",
              "showAsLink": false,
              "valueVariable": {
                "id": "be64f0c8-d6b0-4cc1-934a-1dada430a38a",
                "modelUri": "http://opcfoundation.org/UA/MachineVision/AMCM/",
                "nodeId": "ns=1;i=6003",
                "displayName": "NextService",
                "variablePath": "MaintenanceInfo.NextService",
                "dataType": "UtcTime",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Start of Warranty",
              "showAsLink": false,
              "valueVariable": {
                "id": "b6b69e20-0d80-459b-bf80-18be16351777",
                "modelUri": "http://opcfoundation.org/UA/MachineVision/AMCM/",
                "nodeId": "ns=1;i=6001",
                "displayName": "StartOfWarranty",
                "variablePath": "MaintenanceInfo.StartOfWarranty",
                "dataType": "UtcTime",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 2,
              "isPlaceholder": false,
              "badgeValues": [
                {
                  "backgroundColor": "#00b20e",
                  "textColor": "#ffffff",
                  "value": "false",
                  "label": "Calibrated"
                },
                {
                  "backgroundColor": "#ff0000",
                  "textColor": "#ffffff",
                  "value": "true",
                  "label": "Needed"
                }
              ],
              "valueVariable": {
                "id": "cab07dc2-a2d4-49c3-82b9-bdec7086b1c6",
                "modelUri": "http://opcfoundation.org/UA/MachineVision/AMCM/",
                "nodeId": "ns=1;i=6005",
                "displayName": "CalibrationNeeded",
                "variablePath": "MaintenanceInfo.CalibrationNeeded",
                "dataType": "Boolean",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              },
              "label": "Calibration Status"
            }
          ],
          "title": "Maintenance Information"
        },
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Temperature",
              "showAsLink": false,
              "valueVariable": {
                "id": "6afb028f-7a1c-45ef-9c34-939a9da82994",
                "modelUri": "http://opcfoundation.org/UA/MachineVision/AMCM/",
                "nodeId": "ns=1;i=6011",
                "displayName": "Temperature",
                "variablePath": "HealthInfo.Temperature",
                "dataType": "Double",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": true,
                "hasUnit": true,
                "hasRange": false
              }
            },
            {
              "type": 1,
              "isPlaceholder": false,
              "valueVariable": {
                "id": "4e778c71-c376-4a7b-81c7-f55a811945e8",
                "modelUri": "http://opcfoundation.org/UA/MachineVision/AMCM/",
                "nodeId": "ns=1;i=6010",
                "displayName": "RemainingLifeTime",
                "variablePath": "HealthInfo.RemainingLifeTime",
                "dataType": "Byte",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              },
              "label": "Remaining Lifetime",
              "customRangeHigh": 100,
              "customRangeLow": 0
            }
          ],
          "title": "Health Information"
        }
      ]
    },
    {
      "isPlaceholder": true,
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Manufacturer",
              "showAsLink": false,
              "valueVariable": {
                "id": "5e9ea549-4ed7-4088-be77-167263cdc707",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6019",
                "displayName": "Manufacturer",
                "variablePath": "Identification.Manufacturer",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Serial Number",
              "showAsLink": false,
              "valueVariable": {
                "id": "080712f7-3cb3-4f2d-9084-df5489987a2e",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6020",
                "displayName": "SerialNumber",
                "variablePath": "Identification.SerialNumber",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Manufacturer Uri",
              "showAsLink": false,
              "valueVariable": {
                "id": "d0f6fee7-21d7-48d6-a065-53523d0feb9c",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6007",
                "displayName": "ManufacturerUri",
                "variablePath": "Identification.ManufacturerUri",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Model",
              "showAsLink": false,
              "valueVariable": {
                "id": "ef642e86-f296-4a68-aebd-36b4c8551573",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6008",
                "displayName": "Model",
                "variablePath": "Identification.Model",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Initial Operation Date",
              "showAsLink": false,
              "valueVariable": {
                "id": "5d1d5b38-3495-433e-a2dc-2824761351ec",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6006",
                "displayName": "InitialOperationDate",
                "variablePath": "Identification.InitialOperationDate",
                "dataType": "DateTime",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Product Code",
              "showAsLink": false,
              "valueVariable": {
                "id": "0833a550-883a-4b8b-9500-7d76e3a69c10",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6009",
                "displayName": "ProductCode",
                "variablePath": "Identification.ProductCode",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            }
          ],
          "title": "Identification"
        },
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Hours in Operation",
              "showAsLink": false,
              "valueVariable": {
                "id": "49378bcd-b293-4737-9ed8-456860975a8a",
                "modelUri": "http://opcfoundation.org/UA/MachineVision/AMCM/",
                "nodeId": "ns=1;i=6004",
                "displayName": "HoursInOperation",
                "variablePath": "MaintenanceInfo.HoursInOperation",
                "dataType": "UInt64",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false,
                "hasUnit": false,
                "hasRange": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Last Calibration",
              "showAsLink": false,
              "valueVariable": {
                "id": "b7314ee5-0fce-4e8f-b79b-a113d77eabc1",
                "modelUri": "http://opcfoundation.org/UA/MachineVision/AMCM/",
                "nodeId": "ns=1;i=6006",
                "displayName": "LastCalibration",
                "variablePath": "MaintenanceInfo.LastCalibration",
                "dataType": "UtcTime",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Next Calibration",
              "showAsLink": false,
              "valueVariable": {
                "id": "59b8fa69-95db-4705-9397-462cb90e3bff",
                "modelUri": "http://opcfoundation.org/UA/MachineVision/AMCM/",
                "nodeId": "ns=1;i=6007",
                "displayName": "NextCalibration",
                "variablePath": "MaintenanceInfo.NextCalibration",
                "dataType": "UtcTime",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Next Service",
              "showAsLink": false,
              "valueVariable": {
                "id": "be64f0c8-d6b0-4cc1-934a-1dada430a38a",
                "modelUri": "http://opcfoundation.org/UA/MachineVision/AMCM/",
                "nodeId": "ns=1;i=6003",
                "displayName": "NextService",
                "variablePath": "MaintenanceInfo.NextService",
                "dataType": "UtcTime",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Start of Warranty",
              "showAsLink": false,
              "valueVariable": {
                "id": "b6b69e20-0d80-459b-bf80-18be16351777",
                "modelUri": "http://opcfoundation.org/UA/MachineVision/AMCM/",
                "nodeId": "ns=1;i=6001",
                "displayName": "StartOfWarranty",
                "variablePath": "MaintenanceInfo.StartOfWarranty",
                "dataType": "UtcTime",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 2,
              "isPlaceholder": false,
              "badgeValues": [
                {
                  "backgroundColor": "#00b20e",
                  "textColor": "#ffffff",
                  "value": "false",
                  "label": "Calibrated"
                },
                {
                  "backgroundColor": "#ff0000",
                  "textColor": "#ffffff",
                  "value": "true",
                  "label": "Needed"
                }
              ],
              "valueVariable": {
                "id": "cab07dc2-a2d4-49c3-82b9-bdec7086b1c6",
                "modelUri": "http://opcfoundation.org/UA/MachineVision/AMCM/",
                "nodeId": "ns=1;i=6005",
                "displayName": "CalibrationNeeded",
                "variablePath": "MaintenanceInfo.CalibrationNeeded",
                "dataType": "Boolean",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              },
              "label": "Calibration Status"
            }
          ],
          "title": "Maintenance Information"
        },
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 1,
              "isPlaceholder": false,
              "valueVariable": {
                "id": "4e778c71-c376-4a7b-81c7-f55a811945e8",
                "modelUri": "http://opcfoundation.org/UA/MachineVision/AMCM/",
                "nodeId": "ns=1;i=6010",
                "displayName": "RemainingLifeTime",
                "variablePath": "HealthInfo.RemainingLifeTime",
                "dataType": "Byte",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              },
              "label": "Remaining Lifetime",
              "customRangeHigh": 100,
              "customRangeLow": 0
            }
          ],
          "title": "Health Information"
        }
      ],
      "placeholderObject": "Components.<Component>.[PLACEHOLDER]",
      "titleVariable": {
        "id": "c504c6f0-99c8-4290-9fac-6066dafe2242",
        "modelUri": "http://opcfoundation.org/UA/Machinery/",
        "nodeId": "ns=1;i=6014",
        "displayName": "ComponentName",
        "variablePath": "Identification.ComponentName",
        "dataType": "LocalizedText",
        "valueRank": -1,
        "modellingRule": "Mandatory",
        "hasProperties": false
      }
    }
  ]
}
